"use strict";

function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function () {
  "use strict";

  Error.stackTraceLimit = Math.max(100, Error.stackTraceLimit || 0);
  var reStackEntry = /\s+at\s/;
  function splitErrorStack(error) {
    if (!error) return {
      message: "Unknown error",
      lines: []
    };
    if (!error.stack) return {
      message: error.message,
      lines: []
    };
    var lines = error.stack.split("\n");
    var index = lines.findIndex(function (line) {
      return reStackEntry.test(line);
    });
    var message = lines.slice(0, index).join("\n");
    return {
      message: message,
      lines: lines.slice(index)
    };
  }
  function mergeErrors(traceError, mainError) {
    var _traceLines$;
    var _splitErrorStack = splitErrorStack(traceError),
      traceLines = _splitErrorStack.lines;
    var _splitErrorStack2 = splitErrorStack(mainError),
      errorLines = _splitErrorStack2.lines,
      message = _splitErrorStack2.message;
    if ((_traceLines$ = traceLines[0]) !== null && _traceLines$ !== void 0 && _traceLines$.includes("at new TraceablePromise")) {
      traceLines.shift();
      var ignore = ["at Function.reject (<anonymous>)", "at Promise.__proto__.constructor.reject"];
      if (ignore.some(function (test) {
        var _traceLines$2;
        return (_traceLines$2 = traceLines[0]) === null || _traceLines$2 === void 0 ? void 0 : _traceLines$2.includes(test);
      })) traceLines.shift();
    }
    traceLines.reverse();
    errorLines.reverse();
    var i = 0;
    for (; i < errorLines.length && i < traceLines.length && errorLines[i] === traceLines[i]; ++i);
    return {
      message: message,
      promiseAt: traceLines.slice(i).reverse().join("\n"),
      errorAt: errorLines.slice(i).reverse().join("\n"),
      sharedTrace: errorLines.slice(0, i).reverse().join("\n")
    };
  }
  function defaultLogger(msg) {
    console.error(msg);
  }
  var loggerFunction = defaultLogger;
  function setLogger(loggerFn) {
    loggerFunction = loggerFn !== null && loggerFn !== void 0 ? loggerFn : defaultLogger;
  }
  function logger(reason, promise) {
    var pid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : void 0;
    var metadata = promise.__tracedError ? mergeErrors(promise.__tracedError, reason) : {
      message: (reason === null || reason === void 0 ? void 0 : reason.stack) || "Unknown stack",
      promiseAt: "N/A",
      errorAt: "N/A",
      sharedTrace: "N/A"
    };
    var prefix = pid == null ? "" : "(node:".concat(pid, ") ");
    var logMessage = "".concat(prefix, "UnhandledPromiseRejectionWarning\n") + (!promise.__tracedError ? "" : "[ Stacktrace altered by " + "https://github.com/grantila/trace-unhandled ]\n") + metadata.message;
    loggerFunction(logMessage);
    if (typeof Bugsnag !== "undefined") {
      if (metadata.promiseAt.includes("recaptcha__en.js")) {
        return;
      }
      Bugsnag.notify(reason instanceof Error ? reason : new Error("Unhandled rejection: ".concat(reason)), function (event) {
        event.addMetadata("TraceablePromise", {
          "Promise at": metadata.promiseAt,
          "Error at": metadata.errorAt,
          "Shared trace": metadata.sharedTrace,
          "Original reason": _typeof(reason) === "object" ? JSON.stringify(reason) : reason
        });
      });
    }
  }
  var state = {
    resolve: null,
    reject: null
  };
  var TraceablePromise = /*#__PURE__*/function (_Promise) {
    function TraceablePromise(executor) {
      var _this;
      _classCallCheck(this, TraceablePromise);
      _this = _callSuper(this, TraceablePromise, [wrappedExecutor]);
      function wrappedExecutor(resolve, reject) {
        state.resolve = resolve;
        state.reject = reject;
      }
      var resolve = state.resolve;
      var reject = state.reject;
      state.resolve = null;
      state.reject = null;
      var err = new Error("Non-failing tracing error");
      _this.__tracedError = err;
      try {
        executor(resolve, reject);
      } catch (err) {
        reject(err);
      }
      return _this;
    }
    _inherits(TraceablePromise, _Promise);
    return _createClass(TraceablePromise);
  }(/*#__PURE__*/_wrapNativeSuper(Promise));
  window.onunhandledrejection = function (event) {
    logger(event.reason, event.promise);
  };
  window.Promise = TraceablePromise;
  window.setTraceUnhandledLogger = setLogger;
})();
//# sourceMappingURL=trace-unhandled-promises.js.map